<div class="entry-flows-container">
  @if (loading) {
    <div class="loading-container"><app-loading></app-loading></div>
  }
  <div class="flow-list">
    <div class="create-card" (click)="createEntryFlow()">
      <div class="create-text">Create New Entry Flow</div>
      <mat-icon class="add-icon">add_circle</mat-icon>
    </div>
    @for (flow of flows; track flow.name) {
      <div class="card-container">
        <entry-flow-card
          [flow]="flow"
          [isPreview]="false"
          [scootaverse]="scootaverse"
          [getRoomNames]="true"
          (triggerDelete)="deleteEntryFlow($event)"
        ></entry-flow-card>
      </div>
    }
  </div>
</div>
